module.exports = __webpack_public_path__ + "img/chargingpoint-definitive.ac58f83e.svg";